import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell, { inputClass, inputShadow } from "@/components/AuthShell";
import { forgotPassword, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      testId="forgot-password-page"
      title="FORGOT PASSWORD"
      subtitle="We'll email you a reset link."
    >
      {sent ? (
        <div data-testid="forgot-password-sent" className="font-display text-lg text-navy">
          Check your inbox! If that email has an account, a reset link is on its
          way. The link works for 1 hour.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="forgot-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className={inputClass}
            style={inputShadow}
            required
          />
          {error && (
            <div
              data-testid="forgot-error"
              className="font-display text-base text-white rounded-2xl border-4 border-navy px-4 py-2"
              style={{ backgroundColor: "#FF5A36" }}
            >
              {error}
            </div>
          )}
          <button
            data-testid="forgot-submit-btn"
            type="submit"
            disabled={busy}
            className="chunky-btn w-full py-4 text-2xl text-white disabled:opacity-50"
            style={{ backgroundColor: "#FF4D9D" }}
          >
            {busy ? "SENDING..." : "SEND LINK"}
          </button>
        </form>
      )}

      <div className="mt-5 font-display text-base">
        <Link data-testid="back-to-login-link" to="/login" className="text-navy underline">
          Back to log in
        </Link>
      </div>
    </AuthShell>
  );
}
